/*
 * Define a form page to display a list of healthcare contacts.
 * Include the Other input option.
 * The list of programs (choices) must be provided by the calling function.
 */
import css from './pages.module.css'
import { otherChoicePage } from './choicePage'

export const previouslyReportedToPage = propOverrides => {
  const props = {
    pageId: 'previously_reported_to_page',
    fieldName: 'communication_contact',
    choices: [],
    label: 'Who else have you reported this to?',
    className: css.choices,
    labelClassName: css.largeLabel,
    fieldNameOther: 'communication_contact_other',
    labelOther: 'Please enter who you reported this to',
    ...propOverrides
  }

  return otherChoicePage({ ...props })
}
